import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SaveButton from '@/common/customer.additional-data-fields/SaveButton';

const { Customer, UI } = Mobi2Go;
const { verifyAccount, resendVerificationCode, activeVerificationMethods } = Customer.SpoonityLoyalty;

const CODE_RESEND_TIMEOUT = 10000;
const SMS = 'Sms';

const SpoonityAccountVerification = () => {
    const [token, setToken] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isCodeResending, setIsCodeResending] = useState(false);
    const [activeVerifyMethods, setActiveVerifyMethods] = useState(false);
    const [t] = useTranslation('loyalty');
    let isMounted = true;


    useEffect(() => {
        activeVerificationMethods()
            .then(res => {
                if (isMounted) {
                    setActiveVerifyMethods(res)
                }
            })
        return () => {
            isMounted = false
        };
    }, [])

    const onCodeSubmit = async () => {
        setIsLoading(true);

        try {
            const result = await verifyAccount(token);

            setIsLoading(false);

            if (result) {
                setIsSuccess(true);
                Customer.trigger('updateLoyalty');
            }
        } catch (error) {
            setIsLoading(false);
            setToken('');
            UI.centeredAlert({
                id: 'invalid-token',
                title: t('verification_failure_alert_title'),
                body: t('verification_failure_alert_body'),
                temp: true
            });
        }
    }

    const onCodeResend = async () => {
        setIsCodeResending(true);

        try {
            await resendVerificationCode();
        } catch (error) {
            setIsCodeResending(false);
        }

        setTimeout(() => {
            setIsCodeResending(false);
        }, CODE_RESEND_TIMEOUT)
    }

    const className = name => `m2g-customer-verification${name || ''}`;

    if (!activeVerifyMethods) return null;

    return (
        <div className={className()} >
            <p className={className('__text')}>
                {t('verify_account_text')}
            </p>
            <p className={className('-explanation')}>
                {t('customer.verification:explanation', {
                    contact_method:
                        activeVerifyMethods.includes(SMS)
                            ? Customer.getPhoneNumber()
                            : Customer.getEmail(),
                })}
            </p>
            <input
                type='text'
                inputMode='numeric'
                pattern='\d{6}'
                className={className('-code-input m2g-input')}
                id='m2g-customer-verification-code-input'
                placeholder={t('input_placeholder')}
                autoComplete='one-time-code'
                value={token}
                onChange={e => {
                    const {
                        target: { value },
                    } = e;
                    setToken(value);
                }}
                onKeyDown={e => {
                    if (e.key === 'Enter') {
                        onCodeSubmit()
                    }
                }}
            />
            <SaveButton
                handleSave={onCodeSubmit}
                text={t('verify_account_button')}
                baseClass={className}
                saveButtonDisabled={!token || isLoading || isSuccess}
            />
            {isCodeResending
                ?
                <div
                    className="m2g-customer-verification-code-resent"
                >
                    {t('customer.verification:code_sent')}
                </div>
                : (
                <button
                    type="button"
                    // id="m2g-customer-verification-resend-button"
                    className="m2g-customer-verification-resend-button m2g-button m2g-button--bare"
                    onClick={onCodeResend}
                >
                    {t('customer.verification:resend-button-label')}
                </button>
                )
            }
        </div>
    );
}

export default SpoonityAccountVerification;
